import { useGlobal } from '@/utils/useGlobal';
import { EFLogo } from '@/components/UI/svg/stories';
import styled from './index.module.scss';
import EFVideo from '@/components/UI/EFVideo';

const StoryBanner = () => {
    const { useState, useEffect, isMobile, useLang } = useGlobal();
    const { t } = useLang('brandstory');
    const [showMask, setShowMask] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowMask(true);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={`${isMobile ? styled.story_mobilebanner : styled.story_banner}`}>
            <div className="video">
                <EFVideo sources={['/img/stories/common/banner.webm', '/img/stories/common/banner.mp4']} autoPlay loop={false} id="video" muted />
            </div>
            <div className={`${showMask ? 'show' : ''} mask`}>
                {isMobile ? <EFLogo className="logo" /> : <EFLogo className="logo" />}
                <div className="title">{t('banner.title')}</div>
                <div className="desc">{t('banner.desc')}</div>
            </div>
        </div>
    );
};

export default StoryBanner;
